<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from '@/plugins/i18n'
import { useSearchStore } from '@/components/Search/store/index.ts'
import FilterDropdown from '@/components/Search/FilterDropdown.ce.vue';
import AllFiltersModal from '@/components/Search/SearchBar/AllFiltersModal/index.ce.vue';

import iconMyCollections from '@/assets/img/icon-search-filter-my-collections.svg';
import iconOpenMyCollections from '@/assets/img/icon-search-filter-my-collections-active.svg';
import iconCompanyCollection from '@/assets/img/icon-search-filter-company-collection.svg';
import iconOpenCompanyCollection from '@/assets/img/icon-search-filter-company-collection-active.svg';
import iconDocumentType from '@/assets/img/icon-search-filter-document-type.svg';
import iconOpenDocumentType from '@/assets/img/icon-search-filter-document-type-active.svg';
import iconStatus from '@/assets/img/icon-search-filter-status.svg';
import iconOpenStatus from '@/assets/img/icon-search-filter-status-active.svg';
import iconCategories from '@/assets/img/icon-search-filter-categories.svg';
import iconOpenCategories from '@/assets/img/icon-search-filter-categories-active.svg';
import iconOpen from '@/assets/img/icon-search-filter-up-open.svg';
import iconClose from '@/assets/img/icon-search-filter-down.svg';
import { STANDARDS_SEARCH_TAB, COLLECTIONS_SEARCH_TAB } from '@/components/Search/constants.ts';
import CategoriesFilter from '@/components/Search/SearchFilters/Common/CategoriesFilter/index.ce.vue';

//refs
const displayAllFiltersDisplay = ref(false);

//store
const searchStore = useSearchStore()
const { getItem } = searchStore

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

//event handlers
const handleStandardsAllFiltersDisplay = (display: boolean) => {
  displayAllFiltersDisplay.value = display
}

const handleSearch = () => {
  searchStore.searchCollections(false);
  handleStandardsAllFiltersDisplay(false);
}
</script>
<template>
    <div class="search-bar-filters">
        <div class="search-filter-item multiselect myCollections">
            <FilterDropdown
                className="dropdown" 
                :placeholder="t('myCollections')" 
                name="colls[]" 
                :multiple="true"
                :field="`${COLLECTIONS_SEARCH_TAB}.collections`"
                :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.collections`"
                :hasClear="true" 
                :iconMain="iconMyCollections"
                :iconOpenMain="iconOpenMyCollections"
                :iconOpen="iconOpen"
                :iconClose="iconClose"
                :searchable="true"
                :showMoreLink="false"
                :closeOnClickOutside="true"
                :loadOptionsOnClick="true"
                />
        </div>
        <div class="search-filter-item multiselect companyCollection">
            <FilterDropdown
                className="dropdown" 
                :placeholder="t('companySets')" 
                name="dcoll"
                :field="`${COLLECTIONS_SEARCH_TAB}.companyCollection`"
                :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.companyCollection`"
                :hasClear="true" 
                :iconMain="iconCompanyCollection"
                :iconOpenMain="iconOpenCompanyCollection"
                :iconOpen="iconOpen"
                :iconClose="iconClose"
                :searchable="true"
                :showMoreLink="false"
                :closeOnClickOutside="true"
                :closeOnSelect="true"
                :loadOptionsOnClick="true"
                />
        </div>
        <div class="search-filter-item multiselect documentType">
            <FilterDropdown
                className="dropdown" 
                :placeholder="t('documentType')" 
                name="type" 
                :field="`${COLLECTIONS_SEARCH_TAB}.documentType`"
                :lookupField="`lookUpOptions.${COLLECTIONS_SEARCH_TAB}.documentType`"
                :hasClear="true" 
                :iconMain="iconDocumentType"
                :iconOpenMain="iconOpenDocumentType"
                :iconOpen="iconOpen"
                :iconClose="iconClose"
                :searchable="false"
                :showMoreLink="false"
                :closeOnClickOutside="true"
                :loadOptionsOnClick="false"
                />
        </div> 
        <div class="search-filter-item multiselect status">
            <FilterDropdown
                className="dropdown" 
                :placeholder="t('status')" 
                name="include[]" 
                :multiple="true"
                :field="`${COLLECTIONS_SEARCH_TAB}.status`" 
                :lookupField="`lookUpOptions.${STANDARDS_SEARCH_TAB}.status`" 
                :hasClear="true" 
                :iconMain="iconStatus"
                :iconOpenMain="iconOpenStatus"
                :iconOpen="iconOpen"
                :iconClose="iconClose"
                :searchable="false"
                :showMoreLink="false"
                :closeOnClickOutside="true"
                />
        </div>
        <div class="search-filter-item multiselect categories">
            <CategoriesFilter :searchType="COLLECTIONS_SEARCH_TAB" 
                className="dropdown" 
                :useTeleport="false" 
                :closeOnClickOutside="true"
                :iconMain="iconCategories"
                :iconOpenMain="iconOpenCategories"
                :iconOpen="iconOpen"
                :iconClose="iconClose">
            </CategoriesFilter>
        </div> 
        <div class="search-filter-item cta">
            <div class="all-filters">
                <AllFiltersModal :display="displayAllFiltersDisplay" @closeModal="handleStandardsAllFiltersDisplay(false)"  @handleSearch="handleSearch"></AllFiltersModal>
                <div class="search-bar-all-filter" @click="handleStandardsAllFiltersDisplay(true)">{{t('allFIlters')}}</div>
            </div>
            <div class="clear-all">
                <div class="search-bar-clear-filter" @click="searchStore.clearSearchBarFilters(COLLECTIONS_SEARCH_TAB, [])">{{t('clearAll')}}</div>
            </div>
            <div class="spacer">&nbsp;</div>
            <div class="search">
                <div class="search-bar-btn-search" @click="searchStore.searchCollections(false)">&nbsp;</div>
            </div>
        </div>
    </div>
</template>